import awsLogo from "@/assets/aws-logo.png";
import googleCloudLogo from "@/assets/google-cloud-logo.svg";
import azureLogo from "@/assets/azure-logo.png";
import salesforceLogo from "@/assets/salesforce-logo.png";
import oracleLogo from "@/assets/oracle-logo.png";

const Ecosystem = () => {
  const partners = [
    { name: "Amazon AWS", logo: awsLogo },
    { name: "Google Cloud", logo: googleCloudLogo },
    { name: "Microsoft Azure", logo: azureLogo },
    { name: "Salesforce", logo: salesforceLogo },
    { name: "Oracle", logo: oracleLogo }
  ];

  // Duplicate the array for seamless infinite scroll
  const duplicatedPartners = [...partners, ...partners];

  return (
    <section id="ecosystem" className="py-24 px-4 border-y-4 border-foreground bg-secondary">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <div className="inline-block px-6 py-3 bg-accent/10 border-2 border-accent/20 rounded mb-6">
            <span className="text-sm font-bold tracking-[0.3em] text-accent uppercase">Ecosystem Partners</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black mb-4 text-foreground">
            BUILT-IN CHANNELS
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            We integrate with the world's leading <span className="text-foreground font-bold">hyperscaler</span> and <span className="text-foreground font-bold">enterprise ecosystems</span>
          </p>
        </div>

        <div className="relative overflow-hidden">
          {/* Gradient overlays for fade effect */}
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-secondary to-transparent z-10" />
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-secondary to-transparent z-10" />
          
          {/* Scrolling container */}
          <div className="flex animate-scroll">
            {duplicatedPartners.map((partner, index) => (
              <div
                key={`${partner.name}-${index}`}
                className="flex-shrink-0 mx-8 flex items-center justify-center"
                style={{ width: '200px', height: '100px' }}
              >
                <img
                  src={partner.logo}
                  alt={`${partner.name} logo`}
                  className="max-w-full max-h-full object-contain filter grayscale hover:grayscale-0 transition-all duration-300 opacity-60 hover:opacity-100"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 text-center">
          <div className="inline-block px-6 py-4 bg-accent/10 border-2 border-accent rounded hover:shadow-lg transition-shadow">
            <p className="text-base md:text-lg font-black uppercase tracking-wider text-accent">
              + Regional Distribution Networks Across Middle East
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Ecosystem;
